//NOSONAR
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {FieldType} from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import {restore} from "./../../../../assets/json/restoreTooltip.en";
import { Subscription } from "rxjs";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-lum-info",
  templateUrl: "./lum-info.component.html",
  styleUrls: ["./lum-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LumInfoComponent
  extends FieldType
  implements OnInit, OnChanges, OnDestroy
{
  @Input() field;
  filedName: LegacyAny = [];
  ngModelval: LegacyAny = [];
  JSONOb: LegacyAny = [];
  luminchange: boolean = false;
  emptyFields: boolean = false;
  isInitialLoad: boolean = true;
  isPopulating: boolean = false; // Flag to prevent updates during value population
  isManualReset = false; // Flag to prevent re-population after manual reset
  hasContentFormatError: boolean = false; // True when device reported "Invalid Content format ID"
  private luminDefaultValueSubscription: Subscription;
  private defaultContentIdentifierVersion: number | undefined;

  columnList1: LegacyAny = {
    OemGtin: "Luminaire manufacturer GTIN",
    OemIdentification: "Identification number",
    AdditionalInfo: "Additional info",
    UseDeviceUid: "Use device UID",
    LuminaireIdentification: "Luminaire identification",
    LuminaireManufactureDate: "Luminaire date of manufacture",
    LuminaireManufactureWeek: "Luminaire manufacture week",
    LuminaireManufactureYear: "Luminaire manufacture year",
    UseDynamicDateIndicator: "Use production date",
    LuminaireManufactureName: "Luminaire manufacturer name",
    LuminaireStyle: "Luminaire style",
    LuminaireLightSource: "Luminaire light source",
    LuminaireColor: "Luminaire color",
    LightDistribution: "Light distribution",
    LuminaireColorCode: "Luminaire color code",
    NominalInputPower: "Nominal input power",
    MinAcMainsVoltage: "Min AC mains voltage",
    MaxAcMainsVoltage: "Max AC mains voltage",
    PowerMinDim: "Power of min dim level",
    InputpowerBandNominal: "Input power error band at nominal input power",
    InputpowerBandPhysicalMin: "Input power error band at physical min level",
    DimlevelPf90: "DALI dim level at PF = 0.9",
    DimlevelPf70: "DALI dim level at PF = 0.7",
    DimlevelPf80: "DALI dim level at PF = 0.8",
    NominalLightOutput: "Nominal light output",
    CRI: "CRI",
    CCT: "CCT",
    ContentIdentifier: "Content identifier",
    DistributionType: "Light distribution type",
    curvSelection: "Curve selection",
    IndependentOccupancySensor: "Independant occupancy sensor preset",
    LsiDevicePresent: "LSI device preset",
    OemName: "OEM name",
    CustomerStockingNumber: "Customer stocking number",
    LampCurrentAt100PercentageArcPower: "Lamp current at 100% arc power",
    CustomerUseCharacters: "Customer use characters",
  };

  columnList = [];
  column: LegacyAny = [];
  properties: LegacyAny;
  defaultRestoring: boolean = true;
  formatVersion;
  dynamIndicator;
  useDeviceID;
  errorPattern: LegacyAny = [];
  errorPatternGtin = false;
  isEdited: boolean;
  fieldPatterns: LegacyAny = [];
  fieldMaxVal: LegacyAny = [];
  UseDynamicDateIndicator: boolean;
  implemented_209: boolean;
  UseDeviceUidChecking: boolean;
  reqiredProperties: LegacyAny;
  restoreText = restore;
  fileResponse: LegacyAny;
  disableCCT: boolean;
  checkMaxString: LegacyAny = [];
  displayVersions: LegacyAny = [
    "Unformatted Content",
    "Luminaire info version 1",
    "Luminaire info - v3 (DALI Part 251/ANSI C137.4)",
    "Luminaire info - v4 (DALI Part 251/ANSI C137.4)",
    "Luminaire info - v5 (DALI Part 251/ANSI C137.4)",
  ];
  selectedVersion: string = this.displayVersions[0];
  typeValue: LegacyAny;
  maskColversionOne: LegacyAny = ["OemIdentification", "OemGtin"];
  maskColversionThree: LegacyAny = [
    "NominalInputPower",
    "PowerMinDim",
    "CCT",
    "DistributionType",
    "CRI",
    "MaxAcMainsVoltage",
    "MinAcMainsVoltage",
    "LuminaireManufactureWeek",
    "LuminaireManufactureYear",
    "NominalLightOutput",
    "OemIdentification",
    "OemGtin",
    "LampCurrentAt100PercentageArcPower",
  ];
  maskFieldMaxValue: LegacyAny;
  maskMaximum: LegacyAny = {
    NominalInputPower: 65535,
    PowerMinDim: 65535,
    CCT: 65535,
    DistributionType: 255,
    CRI: 255,
    MaxAcMainsVoltage: 65535,
    MinAcMainsVoltage: 65535,
    LuminaireManufactureWeek: 255,
    LuminaireManufactureYear: 255,
    NominalLightOutput: 16777215,
    OemIdentification: "18446744073709551615",
    OemGtin: "281474976710655",
    LampCurrentAt100PercentageArcPower: 65535,
  };

  private readonly VERSION_3_NUMERIC_FIELDS = [
    "DistributionType",
    "PowerMinDim",
    "NominalInputPower",
    "NominalLightOutput",
    "LuminaireManufactureYear",
    "LuminaireManufactureWeek",
    "MinAcMainsVoltage",
    "CRI",
    "MaxAcMainsVoltage",
    "CCT",
    "LampCurrentAt100PercentageArcPower"
  ];

  fileResponseUnEdited: LegacyAny;
  isEditedVal: LegacyAny;

  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private availFeat: AvailableFeaturesStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }

  ngOnInit() {
    let versionNumber = 0;
    this.isEditedVal = false;


    // Guard: Ensure field schema is loaded before proceeding
    if (!this.field || !Array.isArray(this.field) || this.field.length === 0) {
      return;
    }

    // Sort the schema variants ascending by ContentIdentifier so that
    // field[0] is always the lowest version supported by the device.
    // The API may return the variants in arbitrary order, but the
    // dropdown (`displayVersions`) is always rendered ascending, so we
    // rely on `field[i]` matching the i-th visible option below.
    this.field.sort((a: LegacyAny, b: LegacyAny) => {
      const va = a?.properties?.ContentIdentifier?.const ?? a?.properties?.ContentIdentifier?.default ?? 0;
      const vb = b?.properties?.ContentIdentifier?.const ?? b?.properties?.ContentIdentifier?.default ?? 0;
      return va - vb;
    });

    this.defaultContentIdentifierVersion = this.field[0]?.properties?.ContentIdentifier?.default;

    this.luminDefaultValueSubscription = this.featureDefaults.getLuminDefaultValue.subscribe((response) => {
      if (response) {
        const luminDefaultRes: LegacyAny = response;
        this.properties = luminDefaultRes;

        // Don't re-populate if user just clicked "Restore Default"
        if (this.isManualReset) {
          return;
        }

        // Check if there's saved data that should be preserved
        const configData = this.appState.getConfigurationData();
        const saveData = this.appState.getSaveSetData();
        const hasExistingData = (configData?.resp?.LumInfoFormat &&
                                Object.keys(configData.resp.LumInfoFormat).length > 0) ||
                                (saveData?.resp?.LumInfoFormat &&
                                Object.keys(saveData.resp.LumInfoFormat).length > 0);

        // Only reset if no existing data exists (which means user clicked "Restore Default")
        // When restoreLuminDefault is called, it removes data from storage first
        if (!hasExistingData) {
          this.resetDefault();
        } else if (!this.isInitialLoad) {
          // On subsequent emissions with data, just update properties but keep values
          // Re-fetch the current saved values to ensure they're retained
          this.fileResponse = configData || saveData;
        }
        this.isInitialLoad = false;

        // Re-evaluate the read-device content-format error after defaults arrive,
        // because resetDefault() / property updates above may have cleared our flags.
        this.detectContentFormatErrorFromReadDevice();
      }
    });
    this.fileResponse = this.appState.getConfigurationData();
    if (
      this.fileResponse?.resp?.LumInfoFormat &&
      typeof this.fileResponse["resp"]["LumInfoFormat"] === "object"
    ) {
      // Handle both array format (legacy) and object format
      if (Array.isArray(this.fileResponse["resp"]["LumInfoFormat"])) {
        // Legacy array format: [{key: "ContentIdentifier", value: 3}, ...]
        const contentIdentifierObj = this.fileResponse["resp"]["LumInfoFormat"]
          .find((entry: LegacyAny) => entry && entry.key === "ContentIdentifier");
        versionNumber = contentIdentifierObj?.value ?? this.field[0].properties.ContentIdentifier.default;
      } else {
        // Current object format: {ContentIdentifier: 3, ...}
        versionNumber = this.fileResponse["resp"]["LumInfoFormat"]["ContentIdentifier"]
          ?? this.field[0].properties.ContentIdentifier.default;
      }
    } else {
      versionNumber = this.field[0].properties.ContentIdentifier.const
        ? this.field[0].properties.ContentIdentifier.const
        : this.field[0].properties.ContentIdentifier.default;
    }

    this.formatVersion = versionNumber;

    if (
      this.field.length == 1 &&
      this.field[0].title.includes("luminfoformat0")
    ) {
      this.displayVersions = [this.displayVersions[0]];
      this.populateValues(versionNumber);
    } else if (
      this.field.length == 1 &&
      this.field[0].title.includes("luminfoformat1")
    ) {
      this.displayVersions = [this.displayVersions[1]];
      this.populateValues(versionNumber);
    } else if (
      this.field.length == 1 &&
      this.field[0].title.includes("luminfoformat3")
    ) {
      this.displayVersions = [this.displayVersions[2]];
      this.populateValues(versionNumber - 3);
    } else {
      this.displayVersions.splice(0, 2);
      this.populateValues(versionNumber - 3);
    }

    if (versionNumber >= 3) {
      this.selectedVersion = this.displayVersions[versionNumber - 3];
    } else if (versionNumber == 1 || versionNumber == 0) {
      this.selectedVersion = this.displayVersions[versionNumber];
    }

    // Keep feature-supported state aligned with the currently detected
    // LumInfo content version on initial load (read/import flows). Without
    // this, downstream selection logic can fall back to another variant.
    this.availFeat.setLuminfoVersion(versionNumber);
    this.availFeat.luminfoVersionChanged.next(versionNumber);

    if(this.formatVersion > 3) {
      this.defaultRestoring = false;
      this.featureDefaults.setLuminDefaultColor(this.defaultRestoring);
    }

    // Check if device read reported an "Invalid Content format ID" for LumInfoFormat.
    // If so, show the dropdown as non-default with an inline error message.
    this.detectContentFormatErrorFromReadDevice();
  }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {}

  ngOnDestroy() {
    if (this.luminDefaultValueSubscription) {
      this.luminDefaultValueSubscription.unsubscribe();
    }
  }

  /**
   * Detects an "Invalid Content format ID" error reported by the read-device flow.
   * The read-device component pushes such failures into invalidFeatureData, which
   * supported-features.proceed() merges into resp["LumInfoFormat"] as
   * { descriptionList: [...] }. If found here, we show the ContentIdentifier
   * dropdown in a non-default/error state with an inline error message.
   * This does not touch any other feature's state.
   */
  private detectContentFormatErrorFromReadDevice(): void {
    const descriptionList = this.getLumInfoDescriptionList();
    if (!descriptionList) {
      return;
    }
    const hasError = descriptionList.some((d: string) =>
      typeof d === "string" && d.toLowerCase().includes("invalid content format id")
    );
    if (hasError) {
      this.hasContentFormatError = true;
      // Blank the dropdown so the user has to actively pick a supported format.
      // The value "" doesn't match any option, so the <select> renders empty.
      this.selectedVersion = "";
      this.defaultRestoring = false;
      this.featureDefaults.setLuminDefaultColor(false);
      this.aloAoc.setLuminFormInputValidation(true);
      // Component uses OnPush change detection – schedule a view update so the
      // error label and red border become visible.
      this.ref.markForCheck();
    }
  }

  /**
   * Reads the descriptionList from resp["LumInfoFormat"] on configurationData or
   * saveSetData. Returns null if the entry does not carry a descriptionList
   * (i.e. it holds real feature values, not an error payload).
   */
  private getLumInfoDescriptionList(): string[] | null {
    const configData = this.appState.getConfigurationData();
    const saveData = this.appState.getSaveSetData();
    const lumFromConfig = configData?.resp?.LumInfoFormat;
    const lumFromSave = saveData?.resp?.LumInfoFormat;
    for (const candidate of [lumFromConfig, lumFromSave]) {
      if (candidate && Array.isArray(candidate.descriptionList) &&
          candidate.descriptionList.length > 0) {
        return candidate.descriptionList;
      }
    }
    return null;
  }

  /**
   * Removes the { descriptionList: [...] } placeholder from resp["LumInfoFormat"]
   * on configurationData and saveSetData when the user picks a supported format.
   * Only removes the entry if it looks like the error placeholder (has
   * descriptionList and no ContentIdentifier / other value keys).
   */
  private clearLumInfoDescriptionListPlaceholder(): void {
    const isPlaceholder = (v: LegacyAny) => v && Array.isArray(v.descriptionList) &&
      v.ContentIdentifier === undefined;

    const configData = this.appState.getConfigurationData();
    if (configData?.resp?.LumInfoFormat && isPlaceholder(configData.resp.LumInfoFormat)) {
      delete configData.resp.LumInfoFormat;
      this.appState.setConfigurationData(configData);
    }
    const saveData = this.appState.getSaveSetData();
    if (saveData?.resp?.LumInfoFormat && isPlaceholder(saveData.resp.LumInfoFormat)) {
      delete saveData.resp.LumInfoFormat;
      this.appState.setSaveSetData(saveData);
    }
  }

  onChangeVersion(index) {
    this.luminchange = true;

    // User picked a supported format from the dropdown -> clear the read-device error state.
    if (this.hasContentFormatError) {
      this.hasContentFormatError = false;
      this.aloAoc.setLuminFormInputValidation(false);
      // Remove the error placeholder from configurationData / saveSetData so
      // populateValues() does not read descriptionList as if it were feature values.
      this.clearLumInfoDescriptionListPlaceholder();
    }

    this.populateValues(index);
    this.checkfields();
    this.checkDefaultVersion();
    this.checkAdditionalInfo();

    // Emit the selected version to ApiService
    const version = this.getLuminfoVersionFromIndex(index);
    this.availFeat.setLuminfoVersion(version);

    this.availFeat.luminfoVersionChanged.next(version);

  }

  populateValues(index) {
    if (!this.field || !this.field[index] || !this.field[index].properties) {
      return;
    }

    this.initializeFieldProperties(index);

    if (!this.luminchange) {
      this.populateDefaultValues(index);
      this.applyManufactureDates();
      const isConfigEdited = this.processUnselectedFeature();

      if (!isConfigEdited) {
        this.populateFromDataSource();
      }

      this.checkDefault();
      this.setLuminValue(this.JSONOb);
    } else {
      this.populateLuminChangeMode(index);
    }
  }

  private initializeFieldProperties(index: number): void {
    this.filedName = [];
    this.formatVersion = this.field[index].properties.ContentIdentifier.default;
    const saveData = this.appState.getSaveSetData();

    if (saveData?.resp?.LumInfoFormat) {
      saveData.resp.LumInfoFormat.ContentIdentifier = this.formatVersion;
      this.ngModelval["ContentIdentifier"] = this.formatVersion;
    }

    this.column = this.field[index].requiredProperties;
    this.properties = this.field[index].properties;
    this.reqiredProperties = this.field[index].requiredProperties;
  }

  private populateDefaultValues(index: number): void {
    let i = 0;
    this.columnList = [];

    for (let j = 0; j < this.reqiredProperties.length; j++) {
      const type = this.reqiredProperties[j];
      if (this.column.includes(type)) {
        this.filedName[i] = type;
        if (type !== "") {
          this.setDefaultValueForType(type);
        }

        if (type !== "" && this.formatVersion == 0) {
          this.handleVersion0Fields(type);
        }

        this.validatefields(type, index);
        i++;
      }
    }
  }

  private setDefaultValueForType(type: string): void {
    if (this.shouldClearMaskValue(type)) {
      this.ngModelval[type] = "";
      this.properties[type].default = "";
    } else {
      this.ngModelval[type] = this.properties[type]["default"];
      if (type === "UseDeviceUid") {
        this.useDeviceID = this.properties["UseDeviceUid"]["default"];
        this.UseDeviceUidChecking = this.properties["UseDeviceUid"]["default"];
      }
    }
  }

  private shouldClearMaskValue(type: string): boolean {
    return this.formatVersion >= 3 &&
      (this.maskColversionOne.includes(type) || this.maskColversionThree.includes(type)) &&
      [255, 65535, 0, "18446744073709551615", 16777215, "281474976710655"]
        .includes(this.properties[type]["default"]);
  }

  private handleVersion0Fields(type: string): void {
    if ((type === "OemIdentification" || type === "OemGtin") &&
        ["18446744073709551615", "281474976710655"].includes(this.properties[type]["default"])) {
      this.ngModelval[type] = "";
      this.properties[type].default = "";
    } else {
      this.ngModelval[type] = this.properties[type]["default"];
    }
  }

  private applyManufactureDates(): void {
    if (this.fileResponse?.["resp"]?.["LumInfoFormat"]?.["LuminaireManufactureWeek"] &&
        this.fileResponse["resp"]["LumInfoFormat"]["LuminaireManufactureYear"]) {
      this.ngModelval["LuminaireManufactureYear"] =
        this.fileResponse["resp"]["LumInfoFormat"]["LuminaireManufactureYear"];
      this.ngModelval["LuminaireManufactureWeek"] =
        this.fileResponse["resp"]["LumInfoFormat"]["LuminaireManufactureWeek"];
    }
  }

  private processUnselectedFeature(): boolean {
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    if (!unSelectedFeat) {
      return false;
    }

    let isConfigEdited = false;
    let featIndex = 0;
    this.isPopulating = true;

    unSelectedFeat.forEach((element) => {
      if (this.isLumInfoFormatFeature(element)) {
        isConfigEdited = true;
        this.fileResponseUnEdited = element["featureParameters"][0];
        this.populateFromUneditedFeature();
        unSelectedFeat.splice(featIndex, 1);
        this.appState.setUnSelectedFeatConfig(unSelectedFeat);
      } else {
        featIndex++;
      }
    });

    this.isPopulating = false;
    return isConfigEdited;
  }

  private isLumInfoFormatFeature(element: LegacyAny): boolean {
    return element != null &&
      element["featureName"] != null &&
      element["featureName"].toString().toUpperCase() === "LUMINFOFORMAT";
  }

  private populateFromUneditedFeature(): void {
    let i = 0;
    this.columnList = [];

    for (let j = 0; j < this.reqiredProperties.length; j++) {
      const type = this.reqiredProperties[j];
      if (this.column.includes(type)) {
        this.filedName[i] = type;

        if (this.fileResponseUnEdited[type] || this.fileResponseUnEdited[type] === false) {
          this.applyValueWithMaskCheck(type, this.fileResponseUnEdited[type]);
        } else {
          this.ngModelval[type] = this.properties[type]["default"];
        }

        this.handleSpecialFieldUpdate(type);
        i++;
      }
    }
  }

  private applyValueWithMaskCheck(type: string, value: LegacyAny): void {
    this.typeValue = value;
    this.maskFieldMaxValue = this.maskMaximum[type];

    if (this.shouldApplyMaskValue(type)) {
      this.ngModelval[type] = "";
    } else {
      this.ngModelval[type] = value;
    }
  }

  private shouldApplyMaskValue(type: string): boolean {
    return ((this.maskColversionOne.includes(type) && this.formatVersion === 0) ||
            (this.maskColversionThree.includes(type) && this.formatVersion >= 3)) &&
            this.typeValue === this.maskFieldMaxValue;
  }

  private handleSpecialFieldUpdate(type: string): void {
    if (type === "CCT" && this.ngModelval[type] === 65534) {
      this.partImplemented(true);
    }
    if (type === "UseDynamicDateIndicator" || type === "UseDeviceUid") {
      this.checkboxChanged(type, this.ngModelval[type]);
    }
  }

  private populateFromDataSource(): void {
    if (this.fileResponse?.["resp"]?.["LumInfoFormat"]) {
      this.populateFromResponse(this.fileResponse);
    } else {
      this.populateFromSaveData();
    }
  }

  private populateFromSaveData(): void {
    const saveData = this.appState.getSaveSetData();
    if (saveData?.["resp"]?.["LumInfoFormat"] &&
        Object.keys(saveData["resp"]["LumInfoFormat"]).length > 0) {
      this.fileResponse = saveData;
      this.populateFromResponse(this.fileResponse);
    }
  }

  private populateFromResponse(dataSource: LegacyAny): void {
    this.isPopulating = true;
    let i = 0;
    this.columnList = [];

    for (let j = 0; j < this.reqiredProperties.length; j++) {
      const type = this.reqiredProperties[j];
      if (this.column.includes(type)) {
        this.filedName[i] = type;
        const lumInfoFormatValue = this.extractLumInfoValue(dataSource["resp"]["LumInfoFormat"], type);

        this.applyExtractedValue(type, lumInfoFormatValue);
        this.handleCCTSpecialCases(type);
        this.handleSpecialFieldUpdate(type);
        i++;
      }
    }

    this.isPopulating = false;
  }

  private extractLumInfoValue(lumInfoData: LegacyAny, type: string): LegacyAny {
    if (Array.isArray(lumInfoData)) {
      const item = lumInfoData.find((entry: LegacyAny) => entry.key === type);
      return item ? item.value : this.properties[type]["default"];
    } else if (typeof lumInfoData === "object") {
      const value = lumInfoData[type];
      return value !== undefined ? value : this.properties[type]["default"];
    }
    return lumInfoData[type];
  }

  private applyExtractedValue(type: string, lumInfoFormatValue: LegacyAny): void {
    if (lumInfoFormatValue !== undefined && (lumInfoFormatValue || lumInfoFormatValue === false)) {
      this.typeValue = lumInfoFormatValue;
      this.maskFieldMaxValue = this.maskMaximum[type];

      if (this.shouldApplyMaskValue(type)) {
        this.ngModelval[type] = "";
      } else {
        this.ngModelval[type] = lumInfoFormatValue;
      }
    } else {
      this.ngModelval[type] = lumInfoFormatValue;
    }
  }

  private handleCCTSpecialCases(type: string): void {
    if (type === "CCT" && this.formatVersion >= 3) {
      if (this.appState.getCCTBoolen()) {
        this.partImplemented(true);
      }
    }
  }

  private populateLuminChangeMode(index: number): void {
    for (let j = 0; j < this.reqiredProperties.length; j++) {
      const type = this.reqiredProperties[j];
      if (!(type in this.ngModelval)) {
        if (type == "LampCurrentAt100PercentageArcPower") {
          this.ngModelval[type] = "";
        } else {
          this.ngModelval[type] = this.properties[type]["default"];
        }
      }
      this.filedName[j] = type;
      this.validatefields(type, index);
    }
    this.checkDefault();
    this.setLuminValue(this.JSONOb);
    this.isEditedVal = true;
  }

  setLuminValue(val) {
      this.aloAoc.setLuminValue(val);
    if (this.isEdited) {
      this.setConfigurationData(val, "LumInfoFormat");
    }
  }

  setConfigurationData(value, keyVal) {
    const data = this.appState.getConfigurationData() || {};
    if (!data.resp) data.resp = {};

    // Convert array format [{key: "field", value: "val"}] to object format {field: "val"}
    if (Array.isArray(value)) {
      const convertedValue = {};
      value.forEach(item => {
        if (item && item.key !== undefined) {
          convertedValue[item.key] = item.value;
        }
      });
      data.resp[keyVal] = convertedValue;
    } else if (value && typeof value === 'object') {
      data.resp[keyVal] = value;
    }

    this.appState.setConfigurationData(data);
  }

  checkDefault() {
    this.defaultRestoring = true;
    this.featureDefaults.setLuminDefaultColor(this.defaultRestoring);
    this.isEdited = false;
    this.aloAoc.setLuminValueChanges(false);
    this.JSONOb = [];
    this.aloAoc.setLuminFormInputValidation(false);

    if (!this.properties || !this.reqiredProperties) {
      return;
    }

    for (const value of this.reqiredProperties) {
      const type = value;
      this.JSONOb.push({ key: type, value: this.ngModelval[type] });
      if (this.fieldPatterns[type]) {
        this.validatePattern(type);
      }
      if (this.fieldMaxVal[type] || (this.properties[type] && (this.properties[type]["maximum"] != null || this.properties[type]["minimum"] != null))) {
        this.validateMinMax(type);
      }
      let cctValue;
      if (this.appState.getCCTBoolen()) {
        cctValue = this.appState.getCCTBoolen();
      }
      const isNotDefault = type === "ContentIdentifier"
        ? this.ngModelval[type] !== this.defaultContentIdentifierVersion
        : (this.properties[type] && this.ngModelval[type] !== this.properties[type]["default"]);


      if (
        isNotDefault ||
        cctValue ||
        this.luminchange
      ) {
        this.defaultRestoring = false;
        this.featureDefaults.setLuminDefaultColor(this.defaultRestoring);
        this.isEdited = true;
        this.aloAoc.setLuminValueChanges(true);
      }
    }
  }

  valueChanged(fieldName?) {

    if (
      fieldName === "CCT" &&
      parseInt(this.ngModelval[fieldName]) === 65534
    ) {
      this.errorPattern["CCT"] = false;
      this.partImplemented(true);
    }
    if (fieldName && fieldName !== "OemIdentification" && fieldName !== "OemGtin") {
      for (let j = 0; j < this.JSONOb.length; j++) {
        if (
          this.maskMaximum &&
          parseInt(this.ngModelval[fieldName]) ===
            parseInt(this.maskMaximum[fieldName]) &&
          this.JSONOb[j].key == fieldName
        ) {
          delete this.JSONOb[j];
          this.ngModelval[fieldName] = "";
          if (fieldName === "CRI") {
            this.errorPattern["CRI"] = false;
            this.aloAoc.setLuminFormInputValidation(this.errorPattern["CRI"]);
          }
          this.JSONOb.push({ key: fieldName, value: this.ngModelval[fieldName] });
          this.setLuminValue(this.JSONOb);
        }
      }
    }
    this.checkDefault();
    this.checkfields();
    this.checkDefaultVersion();
    this.setLuminValue(this.JSONOb);
  }

  resetDefault() {
    this.luminchange = false;
    this.hasContentFormatError = false;
    this.aloAoc.setLuminFormInputValidation(false);
    this.selectedVersion = this.displayVersions[0];
    this.fileResponse = "";
    this.isInitialLoad = false; // Reset the flag so future resets work properly
    this.isManualReset = true;

    this.clearLumInfoFromStorage();


    this.populateValues(0);

    // Notify the API service that the version has been reset to the default
    const defaultVersion = this.getLuminfoVersionFromIndex(0);
    this.availFeat.setLuminfoVersion(defaultVersion);
    this.availFeat.luminfoVersionChanged.next(defaultVersion);

    this.defaultRestoring = true;
    if (this.properties["UseDynamicDateIndicator"]) {
      this.dynamIndicator =
        this.properties["UseDynamicDateIndicator"]["default"];
      this.UseDynamicDateIndicator =
        this.properties["UseDynamicDateIndicator"]["default"];
    }
    if (this.properties["UseDeviceUid"]) {
      this.useDeviceID = this.properties["UseDeviceUid"]["default"];
      this.UseDeviceUidChecking = this.properties["UseDeviceUid"]["default"];
    }

    let loadedLuminNg = false;

    // First, reset all existing fields in ngModelval
    for (const type in this.ngModelval) {
      if (this.properties[type]) {
        this.ngModelval[type] = this.properties[type]["default"];
      } else {
        this.ngModelval[type] = "";
      }
      this.errorPattern[type] = false;
      loadedLuminNg = true;
    }
    if (loadedLuminNg === true) {
      if (this.ngModelval["CCT"] != undefined) this.partImplemented(false);
    }
    this.checkDefault();
    this.setLuminValue(this.JSONOb);

    // Build default values object from JSONOb
    const defaultValues = {};
    this.JSONOb.forEach(item => {
      if (item && item.key !== undefined) {
        defaultValues[item.key] = item.value;
      }
    });

    // Get current configuration data to preserve existing structure
    const configData = this.appState.getConfigurationData();

    // Only update LumInfoFormat while preserving other existing properties
    const updatedConfig = {
      ...configData,
      resp: {
        ...(configData?.resp || {}),
        LumInfoFormat: defaultValues
      }
    };

    // Use setConfigurationData to persist properly
    this.appState.setConfigurationData(updatedConfig);

    // Also update saveSetData similarly
    const saveData = this.appState.getSaveSetData() || {};
    const updatedSaveData = {
      ...saveData,
      resp: {
        ...(saveData?.resp || {}),
        LumInfoFormat: defaultValues
      }
    };
    this.appState.setSaveSetData(updatedSaveData);

    this.ref.markForCheck();

    setTimeout(() => {
      this.isManualReset = false;
    }, 100);
  }

  clearLumInfoFromStorage() {
    const data = this.appState.getConfigurationData() || {};
    if (data.resp && data.resp.LumInfoFormat) {
      delete data.resp.LumInfoFormat;
      this.appState.setConfigurationData(data);
    }

    const saveData = this.appState.getSaveSetData() || {};
    if (saveData.resp && saveData.resp.LumInfoFormat) {
      delete saveData.resp.LumInfoFormat;
      this.appState.setSaveSetData(saveData);
    }
  }

  checkboxChanged(e, checked?) {
    const filedid = e.target ? e.target.id : e;
    const checking = e.target ? e.target.checked : checked;
    if (checking) {
      this.ngModelval[filedid] = true;
      if (filedid === "UseDynamicDateIndicator") {
        this.dynamIndicator = true;
        this.UseDynamicDateIndicator = true;
        if (
          this.column.includes("LuminaireManufactureWeek") ||
          this.column.includes("LuminaireManufactureYear")
        ) {
          this.ngModelval["LuminaireManufactureWeek"] = null;
          this.ngModelval["LuminaireManufactureYear"] = null;
        }
      }
      if (filedid === "UseDeviceUid") {
        this.useDeviceID = true;
        this.ngModelval["OemIdentification"] = "";
        this.UseDeviceUidChecking = true;
      }
    } else {
      this.ngModelval[filedid] = false;
      if (filedid === "UseDynamicDateIndicator") {
        this.dynamIndicator = false;
        this.UseDynamicDateIndicator = false;
      }
      if (filedid === "UseDeviceUid") {
        this.useDeviceID = false;
        this.UseDeviceUidChecking = false;
      }
    }
    if (!this.isPopulating) {
      this.valueChanged(filedid);
    }
  }

  validatePattern(e) {
    if (!this.properties || !this.fieldPatterns || !this.fieldPatterns[e]) {
      return;
    }

    const trigger = this.ngModelval[e];
    const regexp = new RegExp(this.fieldPatterns[e]);
    if (regexp.test(trigger)) {
      this.errorPattern[e] = false;
    } else {
      if (
        (this.dynamIndicator === true && e == "LuminaireManufactureDate") ||
        (this.useDeviceID === true && e == "OemIdentification")
      ) {
        this.errorPattern[e] = false;
      } else {
        this.errorPattern[e] = true;
        this.aloAoc.setLuminFormInputValidation(true);
      }
    }
  }

  validateMinMax(filed) {
    if (!this.properties || !this.properties[filed]) {
      return;
    }

    const rawValue = this.ngModelval[filed];
    // explicitly reject any value that is not purely numeric digits.
    if (rawValue !== "" && rawValue !== null && rawValue !== undefined && !/^\d+$/.test(String(rawValue))) {
      this.errorPattern[filed] = true;
      this.aloAoc.setLuminFormInputValidation(true);
      return;
    }

    const num = parseInt(this.ngModelval[filed], 10);
    const min = this.properties[filed]["minimum"];
    const max = this.properties[filed]["maximum"];

    if (this.formatVersion >= 3 && this.VERSION_3_NUMERIC_FIELDS.includes(filed)) {
      this.validateVersion3Field(filed, num, min, max);
    } else if (this.isVersion1VoltageField(filed)) {
      this.validateVersion1VoltageField(filed, num, min, max);
    } else {
      this.setValidationResult(filed, num, min, max);
    }
  }

  private validateVersion3Field(filed: string, num: number, min: number, max: number): void {
    if (this.ngModelval[filed] === "" || this.ngModelval[filed] === null) {
      this.ngModelval[filed] = "";
      this.errorPattern[filed] = false;
      return;
    }

    if (filed === "CCT" && this.ngModelval[filed] === 65535) {
      this.ngModelval[filed] = 65535;
      this.errorPattern[filed] = false;
      return;
    }

    this.setValidationResult(filed, num, min, max);
  }

  private isVersion1VoltageField(filed: string): boolean {
    return this.formatVersion === 1 &&
           (filed === "MinAcMainsVoltage" || filed === "MaxAcMainsVoltage");
  }

  private validateVersion1VoltageField(filed: string, num: number, min: number, max: number): void {
    if (this.ngModelval[filed] === 0 || this.ngModelval[filed] === "0") {
      this.ngModelval[filed] = 0;
      this.errorPattern[filed] = false;
      return;
    }

    this.setValidationResult(filed, num, min, max);
  }

  private setValidationResult(filed: string, num: number, min: number, max: number): void {
    if (isNaN(num) || num < min || num > max) {
      this.errorPattern[filed] = true;
      this.aloAoc.setLuminFormInputValidation(true);
    } else {
      this.errorPattern[filed] = false;
    }
  }

  partImplemented(e) {
    this.disableCCT = false;
    e = e.target ? e.target.checked : e;
    if (e) {
      this.ngModelval["CCT"] = "";
      this.disableCCT = true;
      this.implemented_209 = true;
      this.appState.setCCTBoolen(true);
    } else {
      if (this.ngModelval["CCT"] != "") {
        this.ngModelval["CCT"] = e;
      }
      this.implemented_209 = false;
      this.appState.removeCCTBoolen();
    }
    if (!this.isPopulating) {
      this.valueChanged("CCT");
    }
  }

  otherVersionFields(param) {
    const num = parseInt(this.ngModelval[param], 10),
      min = this.properties[param]["minimum"],
      max = this.properties[param]["maximum"];
    if (
      this.formatVersion == 1 &&
      num == 0 &&
      (param === "MinAcMainsVoltage" || param === "MaxAcMainsVoltage")
    ) {
      this.ngModelval[param] = 0;
      this.errorPattern[param] = false;
    } else if (isNaN(num) || num < min || num > max) {
      // Show red box for out-of-range values instead of silently clamping to defaults
      this.errorPattern[param] = true;
      this.aloAoc.setLuminFormInputValidation(true);
    } else {
      this.errorPattern[param] = false;
    }
    this.valueChanged(param);
  }

  checkDefaultVersion() {
    if (this.formatVersion === 3 && !this.emptyFields) {
      this.defaultRestoring = true;
      this.featureDefaults.setLuminDefaultColor(this.defaultRestoring);
      this.aloAoc.setLuminValueChanges(false);
    }
  }

  onCompositionEnd(event: CompositionEvent, param: string): void {
    // Update model immediately from DOM since Angular defers ngModel updates during IME composition
    const inputElem = event.target as HTMLInputElement;
    if (inputElem) {
      this.ngModelval[param] = inputElem.value;
    }
    this.valueChanged(param);
  }

  onOemGtinCompositionEnd(event: CompositionEvent, param: string): void {
    const inputElem = event.target as HTMLInputElement;
    if (inputElem) {
      this.ngModelval[param] = inputElem.value;
    }
    this.onOemGtinInput(param);
  }

  onOemIdentificationCompositionEnd(event: CompositionEvent, param: string): void {
    const inputElem = event.target as HTMLInputElement;
    if (inputElem) {
      this.ngModelval[param] = inputElem.value;
    }
    this.onOemIdentificationInput(param);
  }

  checkAdditionalInfo() {
    if (
      this.ngModelval["AdditionalInfo"] &&
      this.ngModelval["AdditionalInfo"].length > 0
    ) {
      if (
        this.formatVersion >= 4 &&
        this.ngModelval["AdditionalInfo"].length >
        this.properties["AdditionalInfo"]["maxLength"]
      ) {
        this.ngModelval["AdditionalInfo"] = this.ngModelval[
          "AdditionalInfo"
          ].substring(0, this.properties["AdditionalInfo"]["maxLength"]);
        // Update JSONOb and send to API
        const idx = this.JSONOb.findIndex(obj => obj.key === "AdditionalInfo");
        if (idx !== -1) {
          this.JSONOb[idx].value = this.ngModelval["AdditionalInfo"];
        }
        this.setLuminValue(this.JSONOb);
      }
    }
  }


  checkfields() {
    this.emptyFields = false;
    for (const type in this.ngModelval) {
      if (
        (type === "UseDeviceUid" || type === "UseDynamicDateIndicator") &&
        this.ngModelval[type] !== false
      ) {
        this.emptyFields = true;
        break;
      } else if (
        type !== "ContentIdentifier" &&
        this.ngModelval[type] !== "" &&
        this.ngModelval[type] !== 0 &&
        this.ngModelval[type] !== false
      ) {
        this.emptyFields = true;
        break;
      }
    }
  }

  validatefields(type, index) {
    this.properties[type]["needValidation"] = true;
    if (this.properties[type]["pattern"]) {
      this.fieldPatterns[type] = this.properties[type]["pattern"];
    }

    if (this.formatVersion != 0) {
      this.field[index].allOf.forEach((element) => {
        if (
          element &&
          element.else &&
          element.else.properties[type] &&
          (element.else.properties[type].minimum ||
            element.else.properties[type].maximum)
        ) {
          this.properties[type]["minimum"] =
            element.else.properties[type].minimum;
          this.properties[type]["maximum"] =
            element.else.properties[type].maximum;
          this.properties[type]["needValidation"] = false;
        }
      });
    }

    if (this.properties[type]["maximum"]) {
      this.properties[type]["maxLength"] =
        this.properties[type]["maximum"].toString().length;
      this.fieldMaxVal[type] = this.properties[type]["maximum"];
    }
    if (this.properties[type]["maxLength"]) {
      this.checkMaxString[type] = this.properties[type]["maxLength"];
    }
  }

  getLuminfoVersionFromIndex(index: number): number {
    // Map your index to the actual version number
    // Adjust this logic as per your versioning scheme
    if (this.displayVersions[index].includes("v3")) { return 3; }
    if (this.displayVersions[index].includes("v4")) { return 4; }
    if (this.displayVersions[index].includes("v5")) { return 5; }
    if (this.displayVersions[index].includes("v1") || this.displayVersions[index].includes("version 1")) { return 1; }
    return 0;
  }

  onOemGtinInput(param: string) {
    const val = this.ngModelval[param];
    // Normalize: remove all whitespace, convert to string, strip leading zeros
    const normalized = (val !== undefined && val !== null) ? val.toString().replace(/\s+/g, "").replace(/^0+/, "") : "";
    if (normalized === "281474976710655") {
      this.ngModelval[param] = "";
      this.isEdited = true;
    }
    this.valueChanged(param);
  }

  onPaste(event: ClipboardEvent, param: string) {
    setTimeout(() => {
      // Read value directly from input element
      const inputElem = event.target as HTMLInputElement;
      const val = inputElem ? inputElem.value : this.ngModelval[param];
      const normalized = (val !== undefined && val !== null) ? val.toString().replace(/\s+/g, "").replace(/^0+/, "") : "";
      let defaultValue: string = '';
      if (param === 'OemGtin') {
        defaultValue = "281474976710655";
      }

      if (normalized === defaultValue) {
        this.ngModelval[param] = "";
        if (inputElem) inputElem.value = ""; // force UI blank
        this.isEdited = true;
        this.valueChanged(param);
      } else {
        this.valueChanged(param);
      }
    }, 0);
  }

  onOemIdentificationInput(param: string) {
    const val = this.ngModelval[param];
    // Normalize: remove all whitespace, convert to string, strip leading zeros
    const normalized = (val !== undefined && val !== null) ? val.toString().replace(/\s+/g, "").replace(/^0+/, "") : "";
    if (normalized === "18446744073709551615") {
      this.ngModelval[param] = "";
      this.errorPattern[param] = false;
      this.isEdited = true;
      this.valueChanged(param);
    } else if (normalized !== "" && /^\d+$/.test(normalized)) {
      try {
        const maxValid = BigInt("18446744073709551614");
        const currentValue = BigInt(normalized);
        if (currentValue > maxValid) {
          this.errorPattern[param] = true;
          this.aloAoc.setLuminFormInputValidation(true);
        } else {
          this.errorPattern[param] = false;
        }
      } catch (error) {
        this.errorPattern[param] = true;
        this.aloAoc.setLuminFormInputValidation(true);
      }
      this.checkDefault();
      this.checkfields();
      this.checkDefaultVersion();
      this.setLuminValue(this.JSONOb);
    } else if (normalized === "") {
      this.errorPattern[param] = false;
      this.valueChanged(param);
    } else {
      this.valueChanged(param);
    }
  }

  onOemIdentificationPaste(event: ClipboardEvent, param: string) {
    event.preventDefault();
    const inputElem = event.target as HTMLInputElement;
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';
    const normalized = pastedText.replace(/\s+/g, "").replace(/^0+/, "") || "";
    this.ngModelval[param] = normalized;
    if (inputElem){
       inputElem.value = normalized;
    }
    setTimeout(() => {
      if (normalized === "18446744073709551615") {
        this.ngModelval[param] = "";
        if (inputElem) {
          inputElem.value = "";
        }
        this.errorPattern[param] = false;
        this.isEdited = true;
        this.valueChanged(param);
      } else if (normalized !== "" && /^\d+$/.test(normalized)) {
        try {
          const maxValid = BigInt("18446744073709551614");
          const currentValue = BigInt(normalized);
          if (currentValue > maxValid) {
            this.errorPattern[param] = true;
            this.aloAoc.setLuminFormInputValidation(true);
          } else {
            this.errorPattern[param] = false;
            this.aloAoc.setLuminFormInputValidation(false);
          }
        } catch (error) {
          this.errorPattern[param] = true;
          this.aloAoc.setLuminFormInputValidation(true);
        }
        this.checkDefault();
        this.checkfields();
        this.checkDefaultVersion();
        this.setLuminValue(this.JSONOb);
      } else if (normalized === "") {
        this.errorPattern[param] = false;
        this.aloAoc.setLuminFormInputValidation(false);
        this.valueChanged(param);
      } else {
        this.errorPattern[param] = true;
        this.aloAoc.setLuminFormInputValidation(true);
        this.valueChanged(param);
      }
      this.ref.markForCheck();
    }, 0);
  }
}
